stakeMinusButton = {};

tempPower = 'bigwin';

stakeMinusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  button.stakeController = {};
  button._flags.inPromotion = false;

  button.canEnable = function () {
    return (
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._flags.inPromotion &&
      !this.stakeController.isMinStake()
    );
  };

  button.onPressedCallback = function () {
    this.stakeController.selectPreviousStake();
  };

  button.stakeControllerLoaded = function (controller) {
    this.stakeController = controller;
  };

  button.onGameConfigEvent = function (configEvent) {
    var promotionActive = configEvent.data.slotConfig.promotionActive;
    if (promotionActive !== null && promotionActive !== undefined) {
      this._flags.inPromotion = promotionActive;
    }
  };

  button.onPromotionEnded = function () {
    this._flags.inPromotion = false;
  };

  messageBus.subscribe(
    'stake:stakeControllerLoaded',
    button.stakeControllerLoaded.bind(button)
  );
  messageBus.subscribe(
    'spinner:GameConfigEvent',
    button.onGameConfigEvent.bind(button)
  );
  messageBus.subscribe(
    'common:PromotionEnded',
    button.onPromotionEnded.bind(button)
  );

  return button;
};

stakeMinusButton.initialise = function (json, object) {};
stakeMinusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  'stakeMinusButton',
  stakeMinusButton.create,
  stakeMinusButton.initialise,
  stakeMinusButton.getFilesRequired
);
